import { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  aiAlertsDimensionMappingSelector,
  selectedCustomerNameSelector,
} from '@store/common/selectors';
import { ExportCategory } from './Drawer';
import { generateBrokenAssetExportData } from './BrokenAssets/utils';
import { generateAlertExportData } from './AlertInsights/utils';
import { generateNewAppVersionExportData } from './NewAppVersion/utils';
import { message } from 'antd';
import buildCsv from '@components/export/buildCsv';

export function useExportAutoInsight() {
  const dimensionMapping = useSelector(aiAlertsDimensionMappingSelector);
  const customerName = useSelector(selectedCustomerNameSelector);
  const [isDownLoad, setIsDownLoad] = useState(false);

  return async function (category, e) {
    e.stopPropagation();
    if (isDownLoad) {
      message.error('One download task is processing, please try later');
      return;
    }
    const generateDataHandlerMap = {
      [ExportCategory.BrokenAsset]: generateBrokenAssetExportData,
      [ExportCategory.AIAlertInsights]: generateAlertExportData,
      [ExportCategory.NewAppVersion]: generateNewAppVersionExportData,
    };
    const generateDataParamMap = {
      [ExportCategory.AIAlertInsights]: dimensionMapping,
    };
    try {
      setIsDownLoad(true);
      const exportConfigData = await generateDataHandlerMap[category](
        generateDataParamMap[category],
      );
      buildCsv({
        data: exportConfigData.exportData,
        config: exportConfigData.config,
        customerName,
        metricList: [],
      });
      message.success('download success');
      setIsDownLoad(false);
    } catch (e) {
      message.error('download failed');
      setIsDownLoad(false);
    }
  };
}
